import React from 'react';
import { useDispatch } from 'react-redux';
import {
    Button,
    TextField,
    Grid,
    Typography,
    Container,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    InputLabel,
    InputAdornment,
    OutlinedInput,
    FormGroup,
    Checkbox,
    Radio
} from '@material-ui/core';

import CidadeForm from '../../../components/CidadeForm'

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    subtite: {
        marginTop: theme.spacing(2),
    },
    formControl: {
        minWidth: 120,
    },
}));

export default function EditarVagasForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const vaga = props.vaga

    const [idVaga, setIdVaga] = React.useState()
    const [cargo, setCargo] = React.useState('')
    const [pcd, setPcd] = React.useState('false')
    const [atividades, setAtividades] = React.useState('')
    const [requisitos, setRequisitos] = React.useState('')
    const [salarioMin, setSalarioMin] = React.useState(0)
    const [salarioMax, setSalarioMax] = React.useState(0)

    const [checkVR, setCheckVR] = React.useState(false);
    const [checkVA, setCheckVA] = React.useState(false);
    const [checkRefeitorio, setCheckRefeitorio] = React.useState(false);
    const [checkAM, setCheckAM] = React.useState(false);
    const [checkAO, setCheckAO] = React.useState(false);
    const [checkVT, setCheckVT] = React.useState(false);
    const [checkFretado, setCheckFretado] = React.useState(false);

    const [regime, setRegime] = React.useState('CLT')
    const [numeroVagas, setNumeroVagas] = React.useState(0)
    const [vigenciaVaga, setVigenciaVaga] = React.useState('')

    const [confidencial, setConfidencial] = React.useState('false')


    React.useState(() => {
        setIdVaga(vaga.id)
        setCargo(vaga.title)
        setPcd(`${vaga.isPdc}`)
        setAtividades(vaga.description)
        setRequisitos(vaga.requirement)
        setSalarioMin(vaga.salary_min)
        setSalarioMax(vaga.salary_max)
        const beneficios = vaga.benefit.split(',');
        for (let i = 0; i < beneficios.length; i++) {
            const beneficio = beneficios[i].trim()
            if (beneficio === "VR") {
                setCheckVR(true)
            }
            if (beneficio === "VA") {
                setCheckVA(true)
            }
            if (beneficio === "Refeitorio") {
                setCheckRefeitorio(true)
            }
            if (beneficio === "AM") {
                setCheckAM(true)
            }
            if (beneficio === "AO") {
                setCheckAO(true)
            }
            if (beneficio === "VT") {
                setCheckVT(true)
            }
            if (beneficio === "Fretado") {
                setCheckFretado(true)
            }
        }
        setRegime(vaga.type)
        setNumeroVagas(vaga.quantity)
        setVigenciaVaga(vaga.vigency.substring(0, 10))

        setConfidencial(`${vaga.confidential}`)

        dispatch({
            type: 'SET_UF',
            uf: vaga.city.state.uf
        })

        dispatch({
            type: 'SET_CIDADEID',
            cidadeId: vaga.city.code
        })

    }, [vaga])

    function salaryFormatter(val) { return val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    function salarysFormataded(val_min, val_max) {
        return `${salaryFormatter(val_min)} até ${salaryFormatter(val_max)}`
    }

    onsubmit = (event) => {
        event.preventDefault()
        let beneficios = ""
        if (checkVR) {
            beneficios = beneficios.concat("VR, ")
        }
        if (checkVA) {
            beneficios = beneficios.concat("VA, ")
        }
        if (checkRefeitorio) {
            beneficios = beneficios.concat("Refeitorio, ")
        }
        if (checkAM) {
            beneficios = beneficios.concat("AM, ")
        }
        if (checkAO) {
            beneficios = beneficios.concat("AO, ")
        }
        if (checkVT) {
            beneficios = beneficios.concat("VT, ")
        }
        if (checkFretado) {
            beneficios = beneficios.concat("Fretado")
        }
        if (beneficios.endsWith(", ")) {
            beneficios = beneficios.substring(0, beneficios.length - 2)
        }

        props.onsubmit(idVaga, cargo, pcd, atividades, requisitos, salarioMin, salarioMax,
            beneficios, regime, numeroVagas, vigenciaVaga, confidencial)
    }

    return (
        <Container component="main" maxWidth="md">
            <div className={classes.paper}>
                <form className={classes.form}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="cargo"
                                label="Cargo"
                                name="cargo"
                                autoComplete="lcargo"
                                value={cargo}
                                onChange={(e) => setCargo(e.target.value)}
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">PDC ?</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="gender"
                                    name="pcd"
                                    value={pcd}
                                    onChange={(e) => setPcd(e.target.value)}
                                >
                                    <FormControlLabel value='true' control={<Radio />} label="Sim" />
                                    <FormControlLabel value='false' control={<Radio />} label="Não" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                multiline
                                rows={4}
                                variant="outlined"
                                required
                                fullWidth
                                id="atividades"
                                label="Atividades a serem desenvolvidas"
                                name="atividades"
                                value={atividades}
                                onChange={(e) => setAtividades(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                multiline
                                rows={4}
                                variant="outlined"
                                required
                                fullWidth
                                id="atividades"
                                label="Requisitos necessários/desejáveis"
                                name="atividades"
                                value={requisitos}
                                onChange={(e) => setRequisitos(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <FormControl required fullWidth variant="outlined">
                                <InputLabel htmlFor="salario-min">Salário</InputLabel>
                                <OutlinedInput
                                    type="number"
                                    id="salario-min"
                                    startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                                    labelWidth={60}
                                    value={salarioMin}
                                    onChange={(e) => setSalarioMin(e.target.value)}
                                />
                            </FormControl>
                        </Grid>
                        <Grid
                            container
                            justify="center"
                            alignItems="center"
                            item
                            xs={2}>
                            <Typography variant="subtitle1">
                                Até
                            </Typography>
                        </Grid>
                        <Grid item xs={5}>
                            <FormControl required fullWidth variant="outlined">
                                <InputLabel htmlFor="salario-max">Salário</InputLabel>
                                <OutlinedInput
                                    type="number"
                                    id="salario-max"
                                    startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                                    labelWidth={60}
                                    value={salarioMax}
                                    onChange={(e) => setSalarioMax(e.target.value)}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel>Benefícios</InputLabel>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkVR}
                                            onChange={(e) => setCheckVR(e.target.checked)}
                                            name="VR" />
                                    }
                                    label="VR"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkVA}
                                            onChange={(e) => setCheckVA(e.target.checked)}
                                            name="VA" />
                                    }
                                    label="VA"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkRefeitorio}
                                            onChange={(e) => setCheckRefeitorio(e.target.checked)}
                                            name="refeitorio" />
                                    }
                                    label="Refeitório"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkAM}
                                            onChange={(e) => setCheckAM(e.target.checked)}
                                            name="AM" />
                                    }
                                    label="AM"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkAO}
                                            onChange={(e) => setCheckAO(e.target.checked)}
                                            name="AO" />
                                    }
                                    label="AO"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkVT}
                                            onChange={(e) => setCheckVT(e.target.checked)}
                                            name="VT" />
                                    }
                                    label="VT"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkFretado}
                                            onChange={(e) => setCheckFretado(e.target.checked)}
                                            name="fretado" />
                                    }
                                    label="Fretado"
                                />
                            </FormGroup>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Regime Contratação</FormLabel>
                                <RadioGroup
                                    defaultValue="CLT"
                                    row
                                    aria-label="gender"
                                    name="regimecontratacao"
                                    value={regime}
                                    onChange={(e) => setRegime(e.target.value)}
                                >
                                    <FormControlLabel value="CLT" control={<Radio />} label="CLT" />
                                    <FormControlLabel value="PJ" control={<Radio />} label="PJ" />
                                    <FormControlLabel value="Temporario" control={<Radio />} label="Temporário" />
                                    <FormControlLabel value="Estagio" control={<Radio />} label="Estagio" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="numerovagas"
                                name="numerovagas"
                                label="Numero de vagas"
                                type="number"
                                variant="outlined"
                                value={numeroVagas}
                                onChange={(e) => setNumeroVagas(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                variant="outlined"
                                id="vigenciavaga"
                                name='vigenciavaga'
                                label="Vigência da vaga"
                                type="date"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={vigenciaVaga}
                                onChange={(e) => setVigenciaVaga(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Nome da empresa confidencial ?</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="gender"
                                    name="confidencial"
                                    value={confidencial}
                                    onChange={(e) => setConfidencial(e.target.value)}
                                >
                                    <FormControlLabel value='true' control={<Radio />} label="Sim" />
                                    <FormControlLabel value='false' control={<Radio />} label="Não" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className={classes.subtite} variant="subtitle1">
                                Localização
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <CidadeForm recuperarCidade={true} />
                        </Grid>

                        <Grid item xs={6}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="secondary"
                                className={classes.submit}
                            >
                                Encerrar Vaga
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                            >
                                Alterar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </Container>
    );
}